

//objet contenant des propriétés avec des identificateurs prédéfinis dans Google Maps permettant

//de définir des options d'affichage de notre carte



//constructeur de la carte qui prend en paramêtre le conteneur HTML
//dans lequel la carte doit s'afficher et les options
//var carte = new   google.maps.Map(document.getElementById("bh-sl-map"), options);
function initMap(obj) {
    var visibleMapsOnly = true;
    if (typeof(obj) != "undefined" && typeof (obj.visibleMapsOnly) != "undefined")
    {
        visibleMapsOnly = obj.visibleMapsOnly;
    }

    var geo_map_options = {

        zoom: 19,

        mapTypeId: google.maps.MapTypeId.ROADMAP

    };
   
    $(".geo-map").each(function (index, elem) {
        
        if (visibleMapsOnly == false || (visibleMapsOnly == true && $(elem).is(":visible"))) {
            
            var opt, latlng;

            if ($(elem).attr("data-geo-lat").length > 0
                && $(elem).attr("data-geo-lng").length > 0) {
                var latlng = new google.maps.LatLng($(elem).attr("data-geo-lat"), $(elem).attr("data-geo-lng"));
                opt = geo_map_options;
                opt.center = latlng;
            }


            
            oMap = new google.maps.Map($(elem).get(0), opt);

            if ($(elem).attr("data-geo-marker-content") != undefined > 0) {
                // Creation de l'infobulle avec le contenu passé en param
                infowindow = new google.maps.InfoWindow({
                    content: $("." + $(elem).attr("data-geo-marker-content")).html()
                });
            }

            marker = new google.maps.Marker({
                map: oMap,
                shadow: ""
            });

            marker.setPosition(latlng);

            // Création du marqueur avec le titre passé en param
            if ($(elem).attr("data-geo-marker-title") != undefined) {


                if (typeof ($(elem).attr("data-geo-title")) != "undefined") {
                    marker.setTitle($(elem).attr("data-geo-title"));
                }


                if (($(elem).attr("data-geo-infowindow") != "false")) {

                    google.maps.event.addListener(marker, 'click', function () {
                        infowindow.open(oMap, marker);
                    });


                    // On ouvre par défaut l'infobulle
                    infowindow.open(oMap, marker);
                }
            }

            google.maps.event.trigger(oMap, 'resize');


        }

        //console.log("map :");
        //console.log(map);
    });

}

//let map;

//function initMap() {
//    const localContextMapView = new google.maps.localContext.LocalContextMapView({
//        element: document.getElementById("map"),
//        placeTypePreferences: [
//            { type: "restaurant" },
//            { type: "tourist_attraction" },
//        ],
//        maxPlaceCount: 12,
//    });

//    map = localContextMapView.map;
//    map.setOptions({
//        center: { lat: 51.507307, lng: -0.08114 },
//        zoom: 14,
//    });
//}

